import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EXTERNAL_CPD: {
    DELETE_EXTERNAL_CPD: (externalCpdId, nextRoute) => ({ externalCpdId, nextRoute }),
    API: {
      DELETE_EXTERNAL_CPD: apiResourceActionCreator('externalCpd')
    }
  }
})

export const apiAction = (authToken, externalCpdId, payload) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${externalCpdId}`, authToken, action.externalCpd.api.deleteExternalCpd)

export function* deleteExternalCpd({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.externalCpdId, payload));

  const externalCpdResult = yield apiActionResult(action.externalCpd.api.deleteExternalCpd);

  if (externalCpdResult.success) {
    const {
      nextRoute
    } = payload
    yield put(push({ pathname: nextRoute ? nextRoute : routes.app.professionalProfile.root }));
  }
}

const configuration = {
  name: 'deleteExternalCpd',
  action: action,
  sagas: deleteExternalCpd,
  reducers: {
    request: (state, action) => fp.flow(
      fp.set('request.delete.isFetching')(true),
      fp.set('error')(null)
    )(state),
    success: (state, action) => fp.flow(
      fp.set('request.delete.isFetching')(false),
      fp.set('externalCpd')(action.payload.externalCpd)
    )(state),
    failed: (state, action) => fp.flow(
      fp.set('request.delete.isFetching')(false),
      fp.set('request.delete.error')(action.payload.error),
      fp.set('error')(action.payload.error)
    )(state)
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/deleteExternalCpd.js